<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您所輸入的資料將不會被保留。" content_2="是否確認退出？"></QuitButton>
      <BackButton back_url="forgetPassword"></BackButton>
    </FabColumn>

    <ion-content>
      <MainTitle text="忘記密碼"></MainTitle>
      <InputBox text="用戶名稱" placeholder="請輸入用戶名稱"  @getValue="getName"></InputBox>
      <ConfirmButton text="繼續" position="relative" @click="resetPassword"></ConfirmButton>
    </ion-content>

  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import BackButton from "../components/common/BackButton";
import QuitButton from "../components/common/QuitButton";
import MainTitle from "../components/common/MainTitle";
import ConfirmButton from "../components/common/ConfirmButton";
import common from "../common";
import router from "../router";
import InputBox from "../components/common/InputBox";

export default {
  name: "ForgetPasswordByName",
  components: {
    InputBox,
    ConfirmButton,
    MainTitle,
    QuitButton,
    BackButton,
    WhiteBackground,
    Background,
    IonPage,
    IonContent,
  },
  data() {
    return {
      name: '',
    }
  },
  methods: {
    getName: function (value) {
      this.name = value;
    },
    resetPassword: function () {
      if (!this.name) {
        common.showAlert('請輸入用戶名稱。');
        return ;
      }

      const loading = common.showLoading();
      common.apiPostData('/resetPasswordVerifyName', {name: this.name}, false, loading).then(res => {
        if (res === false) {
          return false;
        }

        router.replace('/mobileVerify/'+res.mobile+'_'+this.name+'/forgetPasswordByName')
      })
    }
  }
}
</script>

<style scoped>

</style>
